// The Dev / Prod publish switch in the Endpoints and Public pages grids.
// Turning one on runs the licence gate in the API (the same requirements
// for dev and prod); a refusal is shown under the switch. "v2 → v3" means a
// newer version exists than the one live there.
import { useMutation } from '@tanstack/react-query'

interface Props {
  label: string
  /** The version live there, or null. */
  version: number | null
  current: number
  /** False when the latest version fails the gate (turning on would be refused). */
  canPublish: boolean
  admin: boolean
  publish: () => Promise<unknown>
  unpublish: () => Promise<unknown>
  onDone: () => void
}

export function EnvToggle(p: Props) {
  const on = p.version != null
  const m = useMutation({ mutationFn: (next: boolean) => (next ? p.publish() : p.unpublish()), onSuccess: p.onDone })
  const stale = on && p.version !== p.current
  return (
    <span className="env-toggle">
      <label title={!p.admin ? 'Admins publish' : !on && !p.canPublish ? 'The latest version does not pass the gate' : ''}>
        <input
          type="checkbox"
          role="switch"
          aria-label={`${p.label}: ${on ? 'published' : 'not published'}`}
          checked={on}
          disabled={!p.admin || m.isPending || (!on && !p.canPublish)}
          onChange={(e) => m.mutate(e.target.checked)}
        />
        <span className={on ? 'on' : ''}>{on ? `v${p.version}` : 'off'}</span>
      </label>
      {stale && p.admin && (
        <button className="btn btn-sm" disabled={m.isPending || !p.canPublish} onClick={() => m.mutate(true)} title={`Publish v${p.current}`}>
          → v{p.current}
        </button>
      )}
      {m.error && <span className="err-t" title={m.error.message}>refused</span>}
    </span>
  )
}
